import { Box, Typography } from '@mui/material';
import classNames from 'classnames';
import { OfficeDetailsProps } from './OfficeDetails.interface';
import classes from './OfficeDetails.module.scss';
import Location2Icon from '@src/icons/Location2Icon';
import PhoneIcon from '@src/icons/PhoneIcon';
import WellnowIcon from '@src/icons/WellnowIcon';
const OfficeDetails: React.FC<OfficeDetailsProps> = ({
  label = [],
  name,
  office,
  distance,
  address,
  phone,
  date,
  service,
  border = false,
  edit = false,
  handleEditClick = () => {
    return;
  }
}) => {
  return <Box className={classNames(classes['frame'], {
    [classes['frame-border']]: border === true
  })} data-test-id="office-details" component="div" data-sentry-element="Box" data-sentry-component="OfficeDetails" data-sentry-source-file="OfficeDetails.tsx">
			{label && label.length > 0 && <Box className={classes['label-container']} data-test-id="label-container" component="div">
					{label.map((lbl, index) => <Box key={index} className={classes['filter-chips']}>
							<Typography data-test-id="label-text" component="span" className={classes['label']}>
								{lbl}
							</Typography>
						</Box>)}
				</Box>}
			<Box data-test-id="office-details-container" component="div" className={classes['location-card-office-details']} data-sentry-element="Box" data-sentry-source-file="OfficeDetails.tsx">
				<Box className={classes['location-card-office']} data-sentry-element="Box" data-sentry-source-file="OfficeDetails.tsx">
					<Box className={classes['location-card-icon-logo']} data-sentry-element="Box" data-sentry-source-file="OfficeDetails.tsx">
						<Box className={classes['wellnow-icon']} data-sentry-element="Box" data-sentry-source-file="OfficeDetails.tsx">
							<WellnowIcon data-test-id="wellnow-icon" className={classes['wellnow-logo']} data-sentry-element="WellnowIcon" data-sentry-source-file="OfficeDetails.tsx" />
						</Box>
					</Box>
					<Box className={classes['location-card-office-1']} data-sentry-element="Box" data-sentry-source-file="OfficeDetails.tsx">
						<Typography data-test-id="office-name" variant="modalHeader" className={classes['location']} data-sentry-element="Typography" data-sentry-source-file="OfficeDetails.tsx">
							{name}
						</Typography>
						<Typography className={classes['office-name']} data-sentry-element="Typography" data-sentry-source-file="OfficeDetails.tsx">{office}</Typography>
					</Box>
				</Box>

				<Box className={classes['location-card-success']} data-sentry-element="Box" data-sentry-source-file="OfficeDetails.tsx">
					{date && <Typography variant="cardContent">{date}</Typography>}
					{service && <Typography variant="cardContent">{service}</Typography>}
				</Box>

				<Box className={classes['location-card-information']} data-sentry-element="Box" data-sentry-source-file="OfficeDetails.tsx">
					{distance && address && <Box className={classes['location-card-address']}>
							<Box className={classes['icons-location-padding']}>
								<Box className={classes['icons-location']}>
									<Location2Icon data-test-id="location-icon" width="30" height="30" className={classes['vector']} />
								</Box>
							</Box>
							<Typography data-test-id="address-text" className={classes['mi-address-here']}>
								{Math.ceil(parseInt(distance, 10))} mi | {address}
							</Typography>
						</Box>}
					{phone && <Box className={classes['location-card-phone-number']}>
							<Box className={classes['icons-padding-phone']}>
								<Box className={classes['icons-phone']}>
									<PhoneIcon data-test-id="phone-icon" width="30" height="30" className={classes['vector']} />
								</Box>
							</Box>
							<a href={`tel:${phone}`} className={classes['phone-number']} aria-label={`Call ${phone}`} data-test-id="phone-link">
								{phone}
							</a>
						</Box>}
					{edit && <Typography variant="editLocation" onClick={handleEditClick}>
							Edit
						</Typography>}
				</Box>
			</Box>
		</Box>;
};
export default OfficeDetails;